import WarningMessage from 'components/elements/items/WarningMessage'
import CallModal from 'components/elements/modal/CallModal'
import ErrorModal from 'components/elements/modal/ErrorModal'
import InformationModal from 'components/elements/modal/InformationModal'
import LoadingModal from 'components/elements/modal/LoadingModal'
import ConfirmContentArea from 'components/templates/RequestedTemplate/ConfirmContentArea'
import RequestTemplate from 'components/templates/RequestTemplate'
import { WARNING } from 'constants/messages'
import { PAGE_PATH } from 'constants/pagePath'
import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'
import { DestinationTypes, QnStatesProps, YesNoSelection } from 'states/QnState'
import { StatesProps } from 'utils/commonHooks'
import { createOptions } from 'utils/commonUtils'
import { isSjDomain } from 'utils/domain'
import {
  useSendAction,
  useSendApi,
  useSendImageAction,
  useSendRequestAction,
  useWatchError,
} from 'utils/informRequester'
import { isDestinationTarget } from 'utils/qnState'
import { useStartWebSocket } from 'utils/websocket'
import RadioButtonGroup from 'components/elements/form/RadioButtonGroup'
import { OTHER_FORM } from '../../constants/qnState'
import Precautions from 'components/elements/items/Precautions'
import { useProgressPoint } from '../../utils/commonHooks'
import { success } from 'utils/status'
import ErrorMessage from 'components/elements/items/ErrorMessage'
// import { EditingItemContext } from 'contexts/EditingItemContext'

/** 同意確認の選択肢 */
const confirmationAgreeOptions = createOptions(
  OTHER_FORM.confirmationAgree.options
)

// テンプレートのボタンラベル
const forwardLabel = 'この内容で今すぐ呼ぶ'
const forwardLabel2 = '日時を指定して呼ぶ'

/**
 * QN-07: 確認画面
 */
// 補償画面が表示対象外になったためコメントアウト(今後再使用する可能性あり)
const Confirmation: React.FC<StatesProps> = (props: QnStatesProps) => {
  const history = useHistory()
  const { state, setState } = props
  // const [editingItem] = React.useContext(EditingItemContext)

  // 車の状況画面～契約情報入力画面で入力した内容をqnStateに反映するイベント
  React.useEffect(() => {
    setState({
      ...state,
      confirmationChangeType: '',
    })
  }, [])

  const [errorCount, setErrorCount] = useState(0)
  const [loadingModal, setLoadingModal] = useState(false)
  const [alertModal, setAlertModal] = useState(false)
  const [errorModal, setErrorModal] = useState(state.sendError)

  //フロント側バリデーションチェック
  const nameKanaInputCheck = !state.contractInfo.nameKana
  const phoneNumberInputCheck = !state.contractInfo.phoneNumber
  const plateNumberInputCheck = !state.contractInfo.plateNumber

  // 送信成功したらWebSocketを起動
  const [sendSuccess, setSendSuccess] = useState(false)
  useStartWebSocket(sendSuccess)

  // 要請者写真登録
  const sendImageAction = useSendImageAction(state)

  // 要請者入力情報連携
  const sendRequestAction = useSendRequestAction(state)

  const sendApi = useSendApi(sendImageAction, sendRequestAction)

  const forwardAction = useSendAction(
    errorModal,
    setLoadingModal,
    setAlertModal,
    sendApi,
    setErrorCount,
    errorCount,
    history,
    setSendSuccess,
    setState,
    state
  )

  /** 日時を指定するを選択したときのイベント */
  const forwardAction2 = React.useCallback(() => {
    setState({
      ...state,
      confirmationChangeType: PAGE_PATH.RESERVATION,
    })
    return success()
  }, [state])

  useWatchError(errorCount, setErrorModal, setState, state, setAlertModal)

  const forwardDisabled = React.useMemo(() => {
    return (
      loadingModal ||
      errorModal ||
      state.confirmationAgree !== YesNoSelection.yes ||
      nameKanaInputCheck ||
      phoneNumberInputCheck ||
      plateNumberInputCheck
    )
  }, [loadingModal, errorModal, state.confirmationAgree])

  const isLocationSelection =
    isDestinationTarget(state) &&
    state.vehicleStateInfo.destinationType === DestinationTypes.specify

  // const compensationItem =
  //   CLIENT_SETTINGS.messages.compensation[state.productKbnCd]

  /** 同意する/しないを切り替えるイベント */
  const handleConfirmationAgreeChanged = React.useCallback(
    (value: YesNoSelection) => {
      setState({
        ...state,
        confirmationAgree: value,
      })
    },
    [state]
  )

  /** 遷移ボタンのクリック時のイベント */
  const forwardTo = React.useMemo(() => {
    return state.reservation.date && state.reservation.time
      ? // 予約日と予約時間の指定がある場合は予約完了画面に遷移する
        PAGE_PATH.RESERVED
      : // 完了画面に遷移する
        PAGE_PATH.INFORMED
  }, [state.reservation.date, state.reservation.time])

  return (
    <RequestTemplate
      title={'ご確認ください'}
      showContact
      progress={useProgressPoint()}
      description={
        '内容をご確認の上、ページ最下部のボタンを押して要請を完了してください。'
      }
      content={
        <React.Fragment>
          <LoadingModal on={loadingModal} />
          <ErrorModal
            on={alertModal}
            message={'送信に失敗しました。もう一度送信してください。'}
          />
          <InformationModal
            on={errorModal}
            content={
              '通信エラーが発生しました。\n大変お手数ですが、\nコールセンターまでお電話を\nお願いいたします。'
            }
            closeLabel={
              <CallModal isTransitionReAccess>電話をかける</CallModal>
            }
            top={'60px'}
            greyBack
            fit
            modalFill
          />
          <ConfirmContentArea state={state} setState={setState} />
          <Precautions />
          {nameKanaInputCheck && (
            <ErrorMessage
              message={'お名前（カナ）を入力してください'}
              justifyContent="left"
            />
          )}
          {phoneNumberInputCheck && (
            <ErrorMessage
              message={'連絡の取れる電話番号を入力してください'}
              justifyContent="left"
            />
          )}
          {plateNumberInputCheck && (
            <ErrorMessage
              message={'トラブル車両のナンバープレート情報を入力してください'}
              justifyContent="left"
            />
          )}

          <RadioButtonGroup
            title={OTHER_FORM.confirmationAgree.formName}
            options={confirmationAgreeOptions}
            selectedValue={state.confirmationAgree}
            onValueChanged={handleConfirmationAgreeChanged}
          />
          {isSjDomain() && (
            <React.Fragment>
              {/* 
              <TitleArea>
                <Text color="var(--color-text-for-main-background)" bold>
                  補償内容
                </Text>
              </TitleArea> */}
              {/* <CompensationList items={compensationItem} isRequested /> */}
              {isLocationSelection && (
                <WarningMessage message={WARNING.WRECKER} />
              )}
            </React.Fragment>
          )}
        </React.Fragment>
      }
      forwardLabel={forwardLabel}
      forwardAction={forwardAction}
      forwardTo={forwardTo}
      isDisabled={forwardDisabled}
      forwardAction2={forwardAction2}
      forwardLabel2={forwardLabel2}
      forwardTo2={PAGE_PATH.RESERVATION}
      isDisabled2={forwardDisabled}
      showBack
      backTo={PAGE_PATH.CONTRACT_INFORMATION}
      notClearEditingItem
    />
  )
}

// const TitleArea = styled.div`
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   height: 39px;
//   margin-top: 16px;
//   background: var(--color-error);
// `

export default Confirmation
